import { IconCheckmark } from '@purpur/library/icon/checkmark';
import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const ChecklistContainer = styled.div`
    margin-top: ${getPurpurSpacing('400')};
    font-size: ${getPurpurTypography('scale75')};
`;

export const ChecklistItem = styled.div`
    display: flex;
    margin-bottom: ${getPurpurSpacing('150')};
`;

export const CheckmarkIcon = styled(IconCheckmark).attrs({ size: 'sm' })`
    margin-right: ${getPurpurSpacing('200')};
`;
